import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import reportWebVitals from './reportWebVitals';
import configureStore from './store';

const store = configureStore();
const root = ReactDOM.createRoot(document.getElementById('app-order-now'));

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

reportWebVitals();
